"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _actionTypes = require("../actions/actionTypes");

var actionTypes = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function dispatchResponse(store, user, status, response) {
    if (status === 200) {
        store.dispatch({
            type: actionTypes.CREATE_STRIPE_TOKEN_SUCCESS,
            user: user,
            token: response.id,
            card: response.card,
            apiResponse: true
        });
    } else {
        // If error.type is 'card_error', this is a problem with customer's card and error.message
        // should be shown to them. Otherwise it is probably a bug, and should be logged.
        store.dispatch({
            type: actionTypes.CREATE_STRIPE_TOKEN_FAILURE,
            error: response.error,
            statusCode: status,
            apiResponse: true
        });
    }
} /**
   * When user submits credit card info, it is dispatched with CREATE_STRIPE_TOKEN action.
   * This middleware submits it to Stripe, and dispatches Stripe token through SUCCESS action
   * (or dispatches error info through FAILURE action).
   */

exports.default = function (store) {
    return function (next) {
        return function (action) {
            if (action.type !== actionTypes.CREATE_STRIPE_TOKEN) return next(action);

            Stripe.setPublishableKey(action.user.stripe);

            Stripe.card.createToken({
                number: action.card.number,
                name: action.card.name,
                cvc: action.card.cvc,
                exp_month: action.card.exp_month,
                exp_year: action.card.exp_year
            }, dispatchResponse.bind(null, store, action.user));

            return next(action);
        };
    };
};